export default "__VITE_ASSET__CXPfZGMQ__"